import { registerNotificationStrategies } from '../../../shared/services/notification/workflow';
import {
  avToDownstreamHandoffStrategy,
  downstreamStatusUpdateToAvStrategy,
  gridShareStrategy,
  meStoppedIndustrializationStrategy,
  meToAvNewComponentStrategy,
  rowDeleteStrategy,
} from './strategies';
import { NOTIFICATION_TYPES } from './types';

export function registerFeatureNotificationStrategies() {
  registerNotificationStrategies({
    [NOTIFICATION_TYPES.ROW_DELETE]: rowDeleteStrategy,
    [NOTIFICATION_TYPES.GRID_SHARE]: gridShareStrategy,
    [NOTIFICATION_TYPES.ME_TO_AV_NEW_COMPONENT]: meToAvNewComponentStrategy,
    [NOTIFICATION_TYPES.ME_STOPPED_INDUSTRIALIZATION]: meStoppedIndustrializationStrategy,
    [NOTIFICATION_TYPES.AV_TO_DOWNSTREAM_HANDOFF]: avToDownstreamHandoffStrategy,
    [NOTIFICATION_TYPES.DOWNSTREAM_STATUS_UPDATE_TO_AV]: downstreamStatusUpdateToAvStrategy,
  });
}
